var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.platform_pc)?_c('router-view'):_vm._e(),(_vm.platform_pc)?[_c('keep-alive',{attrs:{"exclude":"products-info"}},[_c('router-view')],1)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }